import { ca } from '@cian/analytics';

import { TThunkAction } from 'shared/types/redux';
import { getCustomUrl } from 'shared/utils/formatters/getCustomUrl';

import { getCoworkingData } from '../selectors';

export const trackOpenContacts = (): TThunkAction => async (_, getState) => {
  const state = getState();
  const { gaData, custom } = state;

  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_cw_card',
    label: getCustomUrl(gaData, custom),
    products: [getCoworkingData(state)],
  });
};
